import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.wrapper = {
      variant: 'layout.content',
      gridTemplateColumns: ['1fr', null, '.58fr .42fr'],
      columnGap: [0, null, 12],
      pt: [2, 11, 14],
      width: '100%',
      mb: [8, null, 10, 12],

      medias: {
        width: '100%',
        flexShrink: 0,
      },

      details: {
        width: '100%',

        sticky: {
          alignSelf: 'flex-start',
          justifySelf: 'flex-end',
          position: 'sticky',
          pt: 4,
          top: 'calc(var(--header-height) + var(--promoBar-height) + 20px)',
          width: '100%',

          wrapper: {
            variant: 'flex.column',
          },
        },
      },

      metadata: {
        maxWidth: '100%',

        title: {
          text: 'text.h2',
        },

        price: {
          text: 'text.h2',
        },

        description: {
          mt: 3,
          lineHeight: '18px',
        },
      },

      ctas: {
        variant: 'flex.column.start',
      },
    };
  })()
);
